export default __webpack_public_path__ + "static/media/scopus_import.2c30f67c.mp4";